export default __webpack_public_path__ + "static/media/singer_songwriter.94d1602c.png";